import Component from './form-success';
export default Component;
